import Usuario from "../pages/usuario/Usuario";
import GrupoDeUsuario from "../pages/grupoDeUsuario/GrupoDeUsuario";
import NovoUsuario from "../pages/novoUsuario/NovoUsuario";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Sistema from "../pages/sistema/Sistema";
import SistemaNovo from "../pages/novoSistema/NovoSistema";
import NovoGrupoDeUsuario from "../pages/novoGrupoDeUsuario/NovoGrupoDeUsuario";
import Permissoes from "../pages/permissoes/Permissoes";
import Monitor from "../pages/monitor/Monitor";
import Lead from "../pages/lead/Lead";
import Coordenadores from "../pages/coordenadores/Coordenadores";
import Avisos from "../pages/avisos/Avisos";
import Notificacoes from "../pages/notificacoes/Notificacoes";
import NotFound from '../pages/notFound/NotFound';
import Aluno from "../pages/alunos/Alunos";
import Documento from "../pages/documento/Documento";
import Suporte from '../pages/suporte/Suporte';
import ProtectedRouteBackoffice from "./ProtectedRoute";

function Rotas() {
  return (
    <Router>
      <Routes>
        <Route element={<ProtectedRouteBackoffice />}>

          <Route path="/" element={<Usuario />} />
          <Route path="/backoffice/usuario/novo" element={<NovoUsuario />} />
          <Route path="/backoffice/grupoDeUsuario" element={<GrupoDeUsuario />} />
          <Route
            path="/backoffice/grupoDeUsuario/novo"
            element={<NovoGrupoDeUsuario />}
          />
          <Route path="/backoffice/sistema" element={<Sistema />} />
          <Route path="/backoffice/sistema/novo" element={<SistemaNovo />} />
          <Route path="/backoffice/Permissoes" element={<Permissoes />} />
          <Route path="/backoffice/monitores" element={<Monitor />} />
          <Route path="/backoffice/Leads" element={<Lead />} />
          <Route path="/backoffice/Coordenadores" element={<Coordenadores />} />
          <Route path="/backoffice/Avisos" element={<Avisos />} />
          <Route path="/notificacoes" element={<Notificacoes />} />
          <Route path="/backoffice/alunos" element={<Aluno />} />
          <Route path="/backoffice/documento" element={<Documento />} />
          <Route path="/backoffice/suportes" element={<Suporte />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default Rotas;
